import React from 'react'
import { PageHeader } from './react-helmet'
import { Viewport } from './nav'
import { Pullstate } from './pullstate'

export class Layout extends React.Component {

	componentDidMount() {
		const agent = window.navigator.userAgent.toLowerCase()

		if( agent.indexOf("edge") > -1 ) {
			Pullstate.update( s => s.isEdgeHTML = true )
			console.log( "This is EdgeHTML" )
		}
	}

	render() {
		return (
			<>
				<PageHeader />
					<Viewport chapterEnd={this.props.handleChapterEnd} >
							{this.props.children}
					</Viewport>
			</>
		)
	}
}